import React from 'react';
import { Button, Table, Tooltip,Empty} from 'antd';
import TableNivel3 from "./ResultList3";

export default class ResultList2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <Table
                className={'logistica-table-kardex-almacen'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                title={() => (
                    <div style={{ width: '100%', textAlign: "right" }}>
                        <div className="custom-options">
                              {
                                 <Button 
                                 icon="plus"
                                 type="primary"
                                 //loading={this.props.loadingNew}
                                 onClick={this.props.handleNewNivel2}
                               >
                                 Nuevo
                               </Button>
                            }
                        </div>
                    </div>
                )}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.id}
                onExpand={async (expanded, record) => {
                    await this.props.handleSearchNivel2(0,expanded,record);
                }}
                expandedRowRender={(record) => {
                    
                    return (
                        <div style={{ margin: '10px 0px' }}>
                            {
                                <TableNivel3
                                dataSource={record.listaNivel2}
                                handleSearchNivel3={this.props.handleSearchNivel3} 

                                handleNewNivel3={this.props.handleNewNivel3} 
                                />
                            }
                        </div>
                    )
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        key: 'options',
                        align: 'center',
                        width: "70px",
                        render: (value, row) => (
                            <div className="custom-options">
                                <Tooltip placement="top" title={"Editar"}>
                                    <Button
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        style={{ display: (row.edit ? 'none' : '') }}
                                        onClick={() => { this.props.handleSearchNivel2(row.id,false, row);}
                                         }
                                    />
                                </Tooltip>
                  
                                <Tooltip placement="top" title={"Cancelar"}>
                                    <Button
                                        icon="close"
                                        size={"small"}
                                        style={{ display: (row.edit ? '' : 'none') }}
                                        onClick={() => this.props.onEdit(0)}
                                    />
                                </Tooltip>
                            </div>
                        )
                    },
                    {
                        title: 'Elemento',
                        dataIndex: 'elemento',
                        key: 'elemento',
                        align: "center"
                    },
                    {
                        title: 'Código Cuenta',
                        dataIndex: 'codigoCuenta',
                        key: 'codigoCuenta',
                        align: "center"
                    },
                    {
                        title: 'Descripción',
                        dataIndex: 'descripcion',
                        key: 'descripcion',
                        align: "center"
                    },
                    {
                        title: 'Tipo Cuenta',
                        dataIndex: 'tipoCuenta',
                        key: 'tipoCuenta',
                        align: "center"
                    },
                    {
                        title: 'OP. Asociada',
                        dataIndex: 'OperacionAsociada',
                        key: 'OperacionAsociada',
                        align: "center"
                    },
               
                ]}
            />
        );
    }
}